export const version = "transactions/5.2.0";
//# sourceMappingURL=_version.js.map